<ng-template #modalRef>
  <div class="sale-item-modal pl-modal--{{size}}">
    @if (header) {
<header class="sale-item-modal__header">
      <h1>{{ header }}</h1>
      <button
        type="button"
        class="sale-item-modal__close"
        aria-label="Close"
        (click)="close.emit()">
        <se-fe-icon seFeDataName="remove" seFeDataSize="700" [seFeDataMargin]="false">
        </se-fe-icon>
      </button>
    </header>
}
    <section #scrollRef class="sale-item-modal__content">
      <ng-content select="[role=form]"></ng-content>
    </section>
    @if (showRibbon) {
<div class="sale-item-modal__summary">
      <ng-content select="[role=ribbon-text]"></ng-content>
    </div>
}
    <footer class="sale-item-modal__footer">
      @if (!editable) {
<div class="sale-item-modal__add-another">
        <input
          id="openAnotherModalCheckbox"
          [checked]="openAnotherModalCheckbox"
          type="checkbox"
          (change)="addAnother.emit()" />
        <label for="openAnotherModalCheckbox">Add another</label>
      </div>
}
      <div class="sale-item-modal__actions">
        <div class="cancel-button">
          <se-fe-button seFeDataEmphasis="low" (click)="close.emit()">
            Cancel
          </se-fe-button>
        </div>
        <se-fe-button seFeDataEmphasis="high" (click)="submit.emit()" [seFeDataIsLoading]="submitting">
          {{ submitLabel }}
        </se-fe-button>
      </div>
    </footer>
  </div>
</ng-template>
